import { call, put, takeLatest, delay, select } from "redux-saga/effects"
import { documentsService } from "../services/documents.services"
import { buildContentService } from "../services/build_content.services"
import axiosClient from "axios"
import axios from "../services/axios"
import { clearMultibase } from "../actions/multiAiBase"

import {
	LOAD_DOCUMENTS_OF_CONCEPT,
	HIDE_ALERT,
	LOGOUT,
	SHOW_ALERT,
	VIEWDOCUMENTS_FIND_DOCUMENTS,
	VIEWDOCUMENTS_SEARCH_ERROR,
	LOAD_CONCEPT_FROM_API,
	VIEWDOCUMENTS_SEARCHING,
	VIEWDOCUMENTS_SET_SOURCE_FILTER,
	VIEWDOCUMENTS_LOAD_CURRENT_TERMS,
	VIEWDOCUMENTS__NEED_TO_REFESH_DOCUMENTS,
	GET_TARGET_TERMS_OF_CATEGORY,
	LOAD_SEARCH_FROM_API,
	GET_DYNAMIC_FROM_EMAILS_LIST_REQUEST,
	GET_DYNAMIC_TO_EMAILS_LIST_REQUEST,
} from "../types/index"
import { CONTEXT_TYPE, buildQueryString, clearLocalStorage, payloadParsing, reSortArray, searchTermParse } from "../utils"
import { setFilterJobId } from "../actions/filterActions"
import history from "../utils/history"
import { adminReviewMapSaga } from "./review_sagas"
import { reviewService } from "../services/review.services"

const getStatusByJobId = async (id) => {
	return await axios.get(`/job/${id}`).catch((e) => console.log(e))
}

function* loadDocumentsOfConceptFlow(action) {
	const state = yield select()
	const filtersObject = action.payload

	try {
		let sourceApi = state.sources.docs_sources
		//Get from API
		const concepts = state.viewdocuments.concept_terms
		//This is not working, requires an endpoint
		if (
			concepts.targetTerms.length +
				concepts.includeSpecificTerms.length +
				concepts.ignoreTerms.length +
				concepts.ignoreSpecificTerms.length ===
			0
		) {
			// dispatch(alertActions.hideAlertAction());
			yield put({
				type: HIDE_ALERT,
				payload: null,
			})
			return
		}
		// const response = await documentsService.toolsSearch(concepts.targetTerms.concat(concepts.includeSpecificTerms), concepts.ignoreTerms.concat(concepts.ignoreSpecificTerms), filtersObject, [""], sourceApi);
		const response = yield call(
			documentsService.toolsSearch,
			concepts.targetTerms.concat(concepts.includeSpecificTerms),
			concepts.ignoreTerms.concat(concepts.ignoreSpecificTerms),
			filtersObject,
			[""],
			sourceApi
		)

		if (Object.keys(response.data).length === 2) {
			let auxData = response.data
			if (Array.isArray(response.data.count)) {
				auxData.count = auxData.count[0].myCount
			}
			// dispatch(saveConceptDocs(auxData));
			yield put({
				type: VIEWDOCUMENTS_FIND_DOCUMENTS,
				payload: auxData,
			})
		}
		// dispatch(alertActions.hideAlertAction());
		yield put({
			type: HIDE_ALERT,
			payload: null,
		})

		//dispatch(setForceCloudRefresh(true));
	} catch (error) {
		try {
			if (error.response.status === 403) {
				clearLocalStorage()
				yield put(clearMultibase())
				// dispatch(errorUser());
				yield put({
					type: LOGOUT,
					payload: null,
				})
				return
			}
		} catch (e) {}
		// dispatch(requestConceptAPIError(true));
		yield put({
			type: VIEWDOCUMENTS_SEARCH_ERROR,
			payload: true,
		})
		// dispatch(alertActions.showAlertAction({
		//     msg: 'There was an error. Please, try again and check your connection',
		//     class: 'alert alert-danger'
		// }));
		let alert = {
			msg: "There was an error. Please, try again and check your connection",
			class: "alert alert-danger",
		}
		yield put({
			type: SHOW_ALERT,
			payload: alert,
		})
	}
}

function* loadConceptFromAPIFlow(action) {
	const state = yield select()
	const { concept_id, filters, recordsPerPage, skipCount, sortModel } = action.payload

	const payload = {
		text: [],
		categories: [...concept_id],
		neg_text: "",
		return_count: recordsPerPage,
		skip_count: skipCount,
		suppress_content: false,
		treat_like_concept: false,
		mode: "FILE",
		...filters,
	}

	if (!!sortModel.length) {
		const sort = { field: sortModel[0].field, ordering: sortModel[0].sort === "asc" ? 1 : -1 }
		payload["sort"] = sort
	}
	// dispatch(requestConceptAPI());
	yield put({
		type: VIEWDOCUMENTS_SEARCHING,
		payload: true,
	})
	try {
		let sourceApi = state.sources.docs_sources
		//Get from API
		// dispatch(setCurrentSourceFilter(filters));
		yield put({
			type: VIEWDOCUMENTS_SET_SOURCE_FILTER,
			payload: filters,
		})
		// const response = await documentsService.toolsSearch([], [], filters,[concept_name], false, 10000, cancelToken, sourceApi);
		const response = yield call(documentsService.getDocuments, payload)
		if (response) yield put(setFilterJobId(response?.data?.job_id))

		let jobId = yield call(getStatusByJobId, response?.data?.job_id)

		while ((jobId?.data && jobId.data.job.job_status.success === false) || jobId.data.job.job_status.is_finished === false) {
			yield delay(1000)
			jobId = yield call(getStatusByJobId, response.data.job_id)
		}

		if (jobId?.data && jobId.data.job.job_status.success === true) {
			const concept = yield call(documentsService.searchJobId, response.data.job_id)
			const docIdArray = []
			for (var i = 0; i < concept.data.data.data.length; i++) {
				docIdArray.push(`${concept.data.data.data[i].id}`)
			}

			const response_docsData = yield call(documentsService.getFilesMetadata, docIdArray)

			const sortData = reSortArray(docIdArray, response_docsData.data.data)
			let auxData = response_docsData?.data
			if (Array.isArray(response_docsData.data.data)) {
				auxData.data = sortData
				auxData.count = concept.data.data.count
			}

			yield put({
				type: VIEWDOCUMENTS_FIND_DOCUMENTS,
				payload: auxData,
			})
		}

		//Update saved concept terms
		// const response2 = await buildContentService.conceptIndividual(ext_id);
		const response2 = yield call(buildContentService.conceptIndividual, ext_id)
		if (response2.data.concept.topic.terms.length > 0) {
			var positiveC = response2.data.concept.visual.phrase_count
			//need to join in one array topic.terms and topic.relatedness
			let combined = []
			for (var i = 0; i < response2.data.concept.topic.terms.length; i++) {
				combined.push([response2.data.concept.topic.relatedness[i], response2.data.concept.topic.terms[i]])
			}
			let positiveSearch = combined
				.filter((i) => i[0] >= 0)
				.slice(0, positiveC)
				.map((i) => i[1])
			// dispatch(loadCurrentTerms(positiveSearch));
			yield put({
				type: VIEWDOCUMENTS_LOAD_CURRENT_TERMS,
				payload: positiveSearch,
			})
		}

		// dispatch(alertActions.hideAlertAction());
		yield put({
			type: HIDE_ALERT,
			payload: null,
		})
		// dispatch(requestDocumentsList(false));
		yield put({
			type: VIEWDOCUMENTS__NEED_TO_REFESH_DOCUMENTS,
			payload: false,
		})
	} catch (error) {
		try {
			if (axiosClient.isCancel(error)) {
				return
			}
			if (error.response.status === 403) {
				clearLocalStorage()
				yield put(clearMultibase())
				// dispatch(errorUser());
				yield put({
					type: LOGOUT,
					payload: null,
				})
				return
			}
		} catch (e) {}
		// dispatch(requestConceptAPIError(true));
		yield put({
			type: VIEWDOCUMENTS_SEARCH_ERROR,
			payload: true,
		})
		// dispatch(alertActions.showAlertAction({
		//     msg: 'There was an error. Please, try again and check your connection',
		//     class: 'alert alert-danger'
		// }));
		let alert = {
			msg: "There was an error. Please, try again and check your connection",
			class: "alert alert-danger",
		}
		yield put({
			type: SHOW_ALERT,
			payload: alert,
		})
	}
}

function* getTargetTermsOfCategoryFlow(action) {
	const state = yield select()
	const { categories } = action.payload
	const saved_concepts = state.buildconcept.user_saved_build_concepts
	for (let category of categories) {
		//find id in saved_concepts
		var idConcept = saved_concepts.find((item) => {
			return item.description === category
		})
		if (idConcept) {
			// const response =  await buildContentService.conceptIndividual(idConcept.ext_id);
			const response = yield call(buildContentService.conceptIndividual, idConcept.ext_id)
			try {
				if (response.data.concept.topic.terms.length > 0) {
					var negativeC = response.data.concept.visual.neg_phrase_count
					var positiveC = response.data.concept.visual.phrase_count
					//need to join in one array topic.terms and topic.relatedness
					let combined = []
					for (var i = 0; i < response.data.concept.topic.terms.length; i++) {
						combined.push([response.data.concept.topic.relatedness[i], response.data.concept.topic.terms[i]])
					}
					let positiveSearch = combined
						.filter((i) => i[0] >= 0)
						.slice(0, positiveC)
						.map((i) => i[1])
					let negativeSearch = combined
						.filter((i) => i[0] < 0)
						.slice(0, negativeC)
						.map((i) => i[1])
					// dispatch(loadCurrentTerms(positiveSearch.concat(getState().viewdocuments.currentConceptTargetTerms)));
					let data = positiveSearch.concat(state.viewdocuments.currentConceptTargetTerms)
					yield put({
						type: VIEWDOCUMENTS_LOAD_CURRENT_TERMS,
						payload: data,
					})
				}
			} catch (error) {
				console.log(error)
				try {
					if (error.response.status === 403) {
						clearLocalStorage()
						yield put(clearMultibase())
						// dispatch(errorUser());
						yield put({
							type: LOGOUT,
							payload: null,
						})
						return
					}
				} catch (e) {
					console.log(e)
				}
			}
		}
	}
}

function* loadSearchFromAPIFlow(action) {
	const state = yield select()
	const {
		inputSearch,
		concept_id_list,
		filters,
		recordsPerPage,
		skipCount,
		sortModel,
		your_search_id,
		shared_search_id,
		additional_params,
		restrict_file_ids,
		showDuplicate,
		subject,
	} = action.payload?.params
	// dispatch(requestConceptAPI());

	yield put({
		type: VIEWDOCUMENTS_SEARCHING,
		payload: true,
	})
	try {
		yield put({
			type: VIEWDOCUMENTS_SET_SOURCE_FILTER,
			payload: filters,
		})

		const searchTerms = inputSearch && inputSearch?.length > 0 ? searchTermParse(inputSearch) : []
		const payload = {
			text: searchTerms,
			categories: concept_id_list,
			neg_text: "",
			return_count: recordsPerPage,
			skip_count: skipCount,
			suppress_content: false,
			treat_like_concept: false,
			mode: "FILE",
			remove_duplicates: showDuplicate,
			additional_params: _.cloneDeep(additional_params),
			restrict_file_ids,
			...filters,
		}

		if (subject) {
			payload["subject"] = subject
		}

		if (your_search_id) {
			payload["your_search_id"] = your_search_id
		}
		if (shared_search_id) [(payload["shared_search_id"] = shared_search_id)]

		if (!!sortModel.length) {
			const sort = { field: sortModel[0].field, ordering: sortModel[0].sort === "asc" ? 1 : -1 }
			payload["sort"] = sort
		}

		let response = null
		const newPayload = payloadParsing(payload)
		if (payload?.additional_params?.review_id) {
			const { is_case_admin, review_id, ...restPayload } = newPayload
			response = yield call(reviewService.getReviewSearch, { review_id, is_case_admin }, restPayload)
		} else {
			response = yield call(documentsService.getDocuments, newPayload)
		}

		if (response?.data?.success) {
			const queryString = buildQueryString(payload)
			const url = `${window.location.pathname}?${queryString}`
			history.push(url)

			const ids = response.data.data.map((item) => item.file_id)

			let contextId, context
			if (additional_params?.review_id) {
				contextId = additional_params?.review_id
				context = CONTEXT_TYPE?.REVIEW
			} else if (additional_params?.search_id) {
				contextId = additional_params?.search_id
				context = CONTEXT_TYPE?.SEARCH
			}

			const metadata = yield call(documentsService.getFilesMetadata, ids, contextId, context)
			if (metadata?.data?.data?.length) {
				const sortData = reSortArray(ids, metadata.data.data)
				let responseData = metadata?.data
				if (Array.isArray(metadata?.data?.data)) {
					responseData.data = sortData
					responseData.count = response?.data?.count
				}

				yield put({
					type: VIEWDOCUMENTS_FIND_DOCUMENTS,
					payload: responseData,
				})

				//if review_id & user is caseAdmin
				if (action.payload?.params?.additional_params?.review_id && action.payload?.params?.additional_params?.is_case_admin) {
					//demoData => responseData.data
					yield call(adminReviewMapSaga, responseData.data)
				}
				//get dynamic emails data
				yield put({
					type: GET_DYNAMIC_FROM_EMAILS_LIST_REQUEST,
					payload: payload,
				})

				yield put({
					type: GET_DYNAMIC_TO_EMAILS_LIST_REQUEST,
					payload: payload,
				})
			} else {
				yield put({
					type: VIEWDOCUMENTS_FIND_DOCUMENTS,
					payload: { data: [], count: 0 },
				})
			}
		} else {
			yield put({
				type: VIEWDOCUMENTS_FIND_DOCUMENTS,
				payload: { data: [], count: 0 },
			})
		}

		if (searchTerms?.length > 0) {
			yield put({
				type: VIEWDOCUMENTS_LOAD_CURRENT_TERMS,
				payload: searchTerms,
			})
		}
		/*let jobId = yield call(getStatusByJobId, response?.data?.job_id)

		while ((jobId?.data && jobId.data.job.job_status.success === false) || jobId.data.job.job_status.is_finished === false) {
			yield delay(1000)
			jobId = yield call(getStatusByJobId, response.data.job_id)
		}

		if (jobId?.data && jobId.data.job.job_status.success === true) {
			const concept = yield call(documentsService.searchJobId, response.data.job_id)

			const docIdArray = []
			for (var i = 0; i < concept.data.data.data.length; i++) {
				docIdArray.push(`${concept.data.data.data[i].id}`)
			}

			let contextId, context
			if (additional_params?.review_id) {
				contextId = additional_params?.review_id
				context = CONTEXT_TYPE?.REVIEW
			} else if (additional_params?.search_id) {
				contextId = additional_params?.search_id
				context = CONTEXT_TYPE?.SEARCH
			}

			const response_docsData = yield call(documentsService.getFilesMetadata, docIdArray, contextId, context)

			const sortData = reSortArray(docIdArray, response_docsData.data.data)
			let auxData = response_docsData?.data
			if (Array.isArray(response_docsData.data.data)) {
				auxData.data = sortData
				auxData.count = concept.data.data.count
			}

			yield put({
				type: VIEWDOCUMENTS_FIND_DOCUMENTS,
				payload: auxData,
			})

			if (searchTerms?.length > 0) {
				yield put({
					type: VIEWDOCUMENTS_LOAD_CURRENT_TERMS,
					payload: searchTerms,
				})
			}

			// if (valueAutocomplete.length > 0) {
			// 	yield put({
			// 		type: GET_TARGET_TERMS_OF_CATEGORY,
			// 		payload: {
			// 			categories: valueAutocomplete,
			// 		},
			// 	})
			// }
		}*/

		yield put({
			type: HIDE_ALERT,
			payload: null,
		})

		yield put({
			type: VIEWDOCUMENTS__NEED_TO_REFESH_DOCUMENTS,
			payload: false,
		})
	} catch (error) {
		console.log(error)
		try {
			if (axiosClient.isCancel(error)) {
				return
			}
			if (error.response.status === 403) {
				clearLocalStorage()
				yield put(clearMultibase())
				// dispatch(errorUser());
				yield put({
					type: LOGOUT,
					payload: null,
				})
				return
			}
		} catch (e) {
			console.log(e)
		}
		// dispatch(requestConceptAPIError(true));
		yield put({
			type: VIEWDOCUMENTS_SEARCH_ERROR,
			payload: true,
		})
		// dispatch(alertActions.showAlertAction({
		//     msg: 'There was an error. Please, try again and check your connection',
		//     class: 'alert alert-danger'
		// }));
		let alert = {
			msg: "There was an error. Please, try again and check your connection",
			class: "alert alert-danger",
		}
		yield put({
			type: SHOW_ALERT,
			payload: alert,
		})
	}
}

// Watches for the UPDATEACCOUNTDETAILS_REQUESTING action type
// When it gets it, it will call verificarFlow()
// WITH the action we dispatched
function* viewDocumentsWatcher() {
	// takeLatest() takes the LATEST call of that action and runs it
	// if we we're to use takeEvery, it would take every single
	// one of the actions and kick off a new task to handle it
	// CONCURRENTLY!!!
	yield takeLatest(LOAD_DOCUMENTS_OF_CONCEPT, loadDocumentsOfConceptFlow)
	yield takeLatest(LOAD_CONCEPT_FROM_API, loadConceptFromAPIFlow)
	yield takeLatest(GET_TARGET_TERMS_OF_CATEGORY, getTargetTermsOfCategoryFlow)
	yield takeLatest(LOAD_SEARCH_FROM_API, loadSearchFromAPIFlow)
}

export default viewDocumentsWatcher
